<template>
  <PageVenueFilter
    :value="venueId"
    @input="$store.dispatch('pos/general/selectVenueId', $event)"
  >
    <PurchaseOrders v-if="venueId" :venueId="venueId" />
  </PageVenueFilter>
</template>

<script>
import { mapGetters } from "vuex";
import PageVenueFilter from "@/components/Custom/PageVenueFilter.vue";
import PurchaseOrders from "./PurchaseOrders.vue";

export default {
  components: {
    PageVenueFilter,
    PurchaseOrders,
  },
  computed: {
    ...mapGetters({
      venueId: "pos/general/selectedVenueId",
    }),
  },
};
</script>